interface FlashMessagesProps {
  notice?: string | null
  alert?: string | null
}

export function FlashMessages({ notice, alert }: FlashMessagesProps) {
  return (
    <>
      {notice && (
        <div className="mb-4 p-4 bg-green-100 text-green-800 rounded-md">
          {notice}
        </div>
      )}
      {alert && (
        <div className="mb-4 p-4 bg-red-100 text-red-800 rounded-md">
          {alert}
        </div>
      )}
    </>
  )
}
